module.exports = __webpack_public_path__ + "media/landing_page/bg-bot-mobile-8bc0b7f7.jpg";